export default __webpack_public_path__ + "media/img/map-expand-c4d7f6a26609401ea6bf2d58a3b833ed.svg";